// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customFormInput[data-v-8e6caf2c] {\n  height: 34px !important;\n  max-height: 34px !important;\n}\n.custom-width[data-v-8e6caf2c] {\n  max-width: 220px;\n}\n.custom-width-small[data-v-8e6caf2c] {\n  max-width: 106px;\n}\n.custom-width-small input[data-v-8e6caf2c] {\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
